module.exports = __webpack_public_path__ + "img/swiper6.27c4fe7b.png";